// extracted by mini-css-extract-plugin
export default {"feedback":"Section_feedback__qLO2r","feedback__title":"Section_feedback__title__vNmYb"};